module.exports = __webpack_public_path__ + "img/panelView_defaultBg_2_1.24ce1749.png";